// ✅ login_register.jsx (full updated)
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './style.css';

import Header from "../navbar/Header";
import { Input, message } from "antd";

const Login_Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [formTel, setFormTel] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const role = 'photographer';

    let result = await fetch('http://localhost:5000/register', {
      method: 'POST',
      body: JSON.stringify({ name, email, tel: formTel, password, role }),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (result.ok) {
      message.success("Registered! Please wait for admin verification.");
      navigate("/login");
    } else {
      result = await result.json();
      message.warning(result.message);
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();

    let result = await fetch('http://localhost:5000/login', {
      method: "POST",
      body: JSON.stringify({ email, password }),
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (result.ok) {
      const data = await result.json();
      const token = data.token;

      if (!token || typeof token !== "string") {
        message.error("Invalid token received from server.");
        return;
      }

      localStorage.setItem("token", token);
      const user = jwtDecode(token);
      localStorage.setItem("user", JSON.stringify(user));

      if (user.role === 'admin') {
        navigate('/admin/dashboard');
      } else if (user.role === 'photographer') {
        navigate('/photographer');
      } else {
        navigate('/user/photos');
      }
    } else {
      const error = await result.json();
      if (error.message === "Your account is not yet verified by admin.") {
        message.warning("Your account is not verified. Please wait for admin approval.");
      } else {
        message.warning(error.message);
      }
    }
  };

  function en1() {
    document.getElementById('container').classList.add("active");
  }

  function en2() {
    document.getElementById('container').classList.remove("active");
  }

  return (
    <>
      <Header />
      <div className="row justify-content-center">
        <div className="container-1" id="container">
          <div className="form-container sign-up">
            <form onSubmit={handleSubmit}>
              <h5 style={{ color: '#c51c49' }}>Photographer Registration</h5>
              <input type="text" placeholder="Photographer Name" onChange={(e) => setName(e.target.value)} />
              <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
              <input type="tel" placeholder="Phone" value={formTel} onChange={(e) => setFormTel(e.target.value)} />
              <Input.Password type="password" placeholder="Password" minLength={8} onChange={(e) => setPassword(e.target.value)} />
              <button type="submit" style={{ marginTop: '10px' }}>Sign Up</button>
            </form>
          </div>

          <div className="form-container sign-in">
            <form onSubmit={handleSubmit2}>
              <h5 style={{ color: '#c51c49' }}>Sign In</h5>
              <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
              <input type="password" placeholder="Password" minLength={8} onChange={(e) => setPassword(e.target.value)} />
              <Link to={"/forgetpassword"}>Forget Your Password?</Link>
              <button type="submit">Sign In</button>
            </form>
          </div>

          <div className="toggle-container">
            <div className="toggle">
              <div className="toggle-panel toggle-left">
                <h1>Welcome Back!</h1>
                <p>Enter your credentials to continue</p>
                <button className="hidden" id="login" onClick={en2}>Sign In</button>
              </div>
              <div className="toggle-panel toggle-right">
                <h1>Photographer Sign Up</h1>
                <p>Only verified photographers should register here</p>
                <button className="hidden" id="register" onClick={en1}>Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Login_Register;